import { Component } from '@angular/core';

import { PanicProvider } from '../../providers/panic/panic';

@Component({
  selector: 'panic',
  templateUrl: 'panic.html'
})
export class PanicComponent {

  constructor(
    private panicProvider: PanicProvider
  ) {
  }

  test() {
    this.panicProvider.activatePanic();
  }
}



// WEBPACK FOOTER //
// ./src/components/panic/panic.ts